import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { miniTable } from "MODULES/shared/decorators";
import { monthYear, shortDateYY } from "LIB/formatters/date";
import { getFirstNameLastInitial, properCase } from "LIB/formatters/text";
import { dollars } from "LIB/formatters/currency";
import withSubscription from "MODULES/Subscription/withSubscription";
import LineItemStatusCell from "MODULES/shared/components/LineItemStatusCell";
import {
  NO_INTEREST,
  OUTGOING_LINE_ITEMS
} from "MODULES/OutgoingQuotes/constants";
import {
  DataTable,
  LinkedTableRow,
  CompanyName
} from "MODULES/shared/components";
import HoverFlag from "MODULES/parts/components/HoverFlag";
import api from "APP_ROOT/api";
import OutgoingQuoteNote from "MODULES/OutgoingQuotes/shared/OutgoingQuoteNote";
import { CONDITIONS_WITH_SERVICEABLE } from "APP_ROOT/constants";
import { LookingForFlags } from "MODULES/OutgoingQuotes/shared/LookingForFlags";

export class LineItemsTable extends Component {
  static propTypes = {
    disableRowNav: PropTypes.bool,
    inForm: PropTypes.bool,
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        outgoing_quote_id: PropTypes.number.isRequired,
        quote_type: PropTypes.string.isRequired,
        quantity: PropTypes.number,
        condition: PropTypes.string,
        company_name: PropTypes.string,
        price_per_unit: PropTypes.string,
        no_interest: PropTypes.bool,
        looking_for: PropTypes.bool
      })
    ).isRequired,
    loading: PropTypes.bool.isRequired
  };

  renderRow = (lineItem, i) => (
    <LinkedTableRow
      disabled={this.props.disableRowNav}
      to={`/outgoing-quotes/${lineItem.quote_uuid}`}
      key={lineItem.id}
    >
      <td
        style={{
          backgroundColor: this.props.inForm ? "#383838" : "#292929"
        }}
      >
        {i + 1}
      </td>
      <LineItemStatusCell lineItem={lineItem}>
        <span className={lineItem.updated_tracked_fields_at && "text-yellow"}>
          {shortDateYY(
            lineItem.updated_tracked_fields_at || lineItem.created_at
          )}
        </span>
      </LineItemStatusCell>
      <td className="text-nowrap">
        <CompanyName flattenedCompany={lineItem} truncateAt={18} />
      </td>
      <td className="text-nowrap">
        {lineItem.created_by &&
          getFirstNameLastInitial(lineItem.created_by.full_name)}
      </td>
      <td className="text-nowrap">
        {OUTGOING_LINE_ITEMS.quoteType[lineItem.quote_type].abbrev}
      </td>
      <td className="text-center">{monthYear(lineItem.tag_date)}</td>
      <td className="text-nowrap">
        {lineItem.condition &&
          CONDITIONS_WITH_SERVICEABLE[lineItem.condition].abbrev}
      </td>
      <td className="text-center">{lineItem.quantity}</td>
      <td className="text-right padding-right-zero">
        <LookingForFlags lineItem={lineItem} />
        {lineItem.no_interest && (
          <HoverFlag text={properCase(NO_INTEREST)} abbr="NI" inline />
        )}
      </td>

      <td
        className="text-center padding-horizontal-zero"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        {lineItem.price_per_unit && dollars(lineItem.price_per_unit)}
      </td>
      <OutgoingQuoteNote lineItem={lineItem} />
    </LinkedTableRow>
  );

  render() {
    const { loading, results } = this.props;

    return (
      <DataTable.Mini loading={loading} numbered>
        <DataTable.Head>
          <th />
          <th>Date</th>
          <th>Customer</th>
          <th>Created By</th>
          <th>Type</th>
          <th className="text-center">Tag Date</th>
          <th className="text-center">CD</th>
          <th className="text-center">QTY</th>
          <th className="text-right" />
          <th className="text-center">Price/Unit</th>
        </DataTable.Head>
        <DataTable.Body>{results.map(this.renderRow)}</DataTable.Body>
      </DataTable.Mini>
    );
  }
}

const withResults = miniTable(({ match, pageSize = 5 }) =>
  api.parts.outgoingQuoteLineItems.search_grouped(match.params.id, {
    limit: pageSize
  })
);

export default withRouter(
  withResults(withSubscription("OutgoingQuoteLineItem")(LineItemsTable))
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/OutgoingQuotes/LineItemsTable.jsx